import { convertStateToAbbr, stateOptions } from 'options';

const normalizeStateLabel = (value) =>
  String(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const matchLoadProfileStateOption = (country, state) => {
  if (!state) return '';
  const options = stateOptions[country] || [];
  return (
    options.find((option) => normalizeStateLabel(option) === normalizeStateLabel(state))
    || ''
  );
};

export const prepareLoadProfilePayload = (profile) => {
  const prepared = {
    ...profile,
    usages: (profile.usages || Array(12).fill(400)).map(Number),
  };

  const allRegionsLabel = `All ${
    prepared.country === 'Canada' ? 'Provinces' : 'States'
  }`;

  if (prepared.state === allRegionsLabel) {
    prepared.state = null;
  } else if (prepared.state) {
    const stateWithoutAccents = prepared.state
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');
    prepared.state =
      convertStateToAbbr(stateWithoutAccents, 'abbr') || prepared.state;
  }

  return prepared;
};

export class LoadProfileTypeInUseError extends Error {}

export const ensureLoadProfileType = async ({
  name,
  create,
  listTypes,
  listProfiles,
}) => {
  const [types, profiles] = await Promise.all([listTypes(), listProfiles()]);
  const existing = types.find((type) => type.name === name);

  if (existing) {
    const isInUse = profiles.some((profile) => profile.type === existing.id);
    if (isInUse) {
      throw new LoadProfileTypeInUseError(
        `A load profile named "${name}" already exists.`
      );
    }
    return existing;
  }

  return create({ name });
};
